import { virtualAppCodes } from '@/types/menu'

export function getDetailsMenu(path: string) {
  let menu: Recordable = {}
  const menuMap: Recordable = {
    customerDetail: {
      name: '客户详情',
      appCode: virtualAppCodes.CustomerDetail,
      path: '/customerDetail',
      systemCode: 'CRM'
    },
    clueDetail: {
      name: '线索详情',
      appCode: virtualAppCodes.ClueDetail,
      path: '/clueDetail',
      systemCode: 'CRM'
    },
    clueHighSeasDetail: {
      name: '线索公海详情',
      appCode: virtualAppCodes.ClueHighSeasDetail,
      path: '/clueHighSeasDetail',
      systemCode: 'CRM'
    },
    clueRecycleDetail: {
      name: '线索回收站详情',
      appCode: virtualAppCodes.ClueRecycleDetail,
      path: '/clueRecycleDetail',
      systemCode: 'CRM'
    },
    highSeaDetail: {
      name: '公海详情',
      appCode: virtualAppCodes.HighSeaDetail,
      path: '/highSeaDetail',
      systemCode: 'CRM'
    },
    recycleBinDetail: {
      name: '回收站详情',
      appCode: virtualAppCodes.RecycleBinDetail,
      path: '/recycleBinDetail',
      systemCode: 'CRM'
    }
  }
  for (const key in menuMap) {
    if (path.indexOf(key) > -1) {
      menu = menuMap[key]
    }
  }
  return menu
}
